import React, { useState, useEffect, useRef } from 'react';
import styles from './CuboCarrusel.module.css';

import Front from './Faces/Front';
import Right from './Faces/Right';
import Left from './Faces/Left';
import Back from './Faces/Back';

export const Seccion3 = () => {
    const [pos, setPos] = useState(0);
    const [autoRotate, setAutoRotate] = useState(true);
    const [startX, setStartX] = useState(0);
    const wrapperRef = useRef(null); // Crear la referencia

    const handleNextClick = () => {
        setPos(pos - 90);
        setAutoRotate(false);
    };

    const handlePrevClick = () => {
        setPos(pos + 90);
        setAutoRotate(false);
    };

    const handleTouchStart = (e) => {
        const touch = e.touches[0];
        setStartX(touch.clientX);
        setAutoRotate(false);
    };

    const handleTouchMove = (e) => {
        const touch = e.touches[0];
        const diffX = touch.clientX - startX;
    };

    // Usar useEffect para agregar y remover los eventos táctiles
    useEffect(() => {
        const currentWrapper = wrapperRef.front;
        if (currentWrapper) {
            currentWrapper.addEventListener('touchstart', handleTouchStart);
            currentWrapper.addEventListener('touchmove', handleTouchMove);
        }

        return () => {
            if (currentWrapper) {
                currentWrapper.removeEventListener('touchstart', handleTouchStart);
                currentWrapper.removeEventListener('touchmove', handleTouchMove);
            }
        };
    }, [startX]); // Incluye todas las dependencias necesarias

    useEffect(() => {
        if (!autoRotate) return;

        const startFastRotation = () => {
            setPos(pos => pos - 90);
        };

        setTimeout(startFastRotation, 0);
        setTimeout(startFastRotation, 50);

        const interval = setInterval(() => {
            setPos(pos => pos - 90);
        }, 3000);

        return () => clearInterval(interval);
    }, [autoRotate]);

    return (
        <section className={styles.cuboCarruselSection}>
            <h2 className={styles.sectionTitle}>Vive la experiencia de clones IA</h2>
            <div className={styles.row}>
                <div className={styles.column}>
                    <div className={styles.wrapper} ref={wrapperRef}>
                        <div className={styles.container} onMouseEnter={() => setAutoRotate(false)}>
                            <div className={styles.imageCube} style={{ transform: `rotateY(${pos}deg)` }}>
                                <div className={styles.front}><Front /></div>
                                <div className={styles.right}><Right /></div>
                                <div className={styles.back}><Back /></div>
                                <div className={styles.left}><Left /></div>
                            </div>
                            <div className={styles.btns}>
                                <button id="prev" onClick={handlePrevClick} className={styles.btn}>
                                    <i className="fas fa-arrow-left"></i>
                                </button>
                                <button id="next" onClick={handleNextClick} className={styles.btn}>
                                    <i className="fas fa-arrow-right"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Seccion3;
